import React, { useEffect, useState } from "react"
import { IoIosStats } from "react-icons/io"
import { FaShoppingBag, FaUserPlus } from "react-icons/fa"
import { MdCancel, MdDownloading } from "react-icons/md"
import { PiKeyReturnFill } from "react-icons/pi"
import { Row, Col } from "reactstrap"
import Miniwidget from "./Miniwidget"
import ApplicationsStatusChart from "./applications-status-chart"
import EmailSent from "./email-sent"
import MonthlyEarnings2 from "./montly-earnings2"
import Inbox from "./inbox"
import RecentActivity from "./recent-activity"
import WidgetUser from "./widget-user"
import YearlySales from "./yearly-sales"
import LatestTransactions from "./latest-transactions"
import LatestOrders from "./latest-orders"
import { useDispatch, useSelector } from "react-redux"
import {
  ApplicationStatusCountsFetch,
  allApplications,
} from "redux/slice/applications/applicationSlice"
import ReturningApplications from "./returning-applications"
import LatestUpdates from "./latest-updated-applications"

const Dashboard = () => {
  document.title = "Shukre Ilahi"
  const dispatch = useDispatch()
  const { applicationStatusCounts } = useSelector(allApplications)
  const [statusCounts, setStatusCounts] = useState({
    Total: 0,
    New: 0,
    Process: 0,
    Accepted: 0,
    Hold: 0,
    Rejected: 0,
    Returning: 0,
  })

  useEffect(() => {
    dispatch(ApplicationStatusCountsFetch())
  }, [dispatch])

  useEffect(() => {
    if (!applicationStatusCounts) return
    const c = applicationStatusCounts
    const next = {
      New: c.newApplication || 0,
      Process: c.inProcessApplication || 0,
      Accepted: c.acceptedApplication || 0,
      Hold: c.holdApplication || 0,
      Rejected: c.rejectedApplication || 0,
      Returning: c.returningApplication || 0,
    }
    next.Total =
      next.New +
      next.Process +
      next.Accepted +
      next.Hold +
      next.Rejected +
      next.Returning
    setStatusCounts(next)
  }, [applicationStatusCounts])

  const reports = [
    {
      statusId: "New",
      title: "New Application",
      icon: <FaShoppingBag />,
      total: statusCounts.New,
      average:
        statusCounts.Total > 0
          ? (statusCounts.New / statusCounts.Total) * 100
          : 0,
      badgecolor: "#f5b225",
    },
    {
      statusId: "In Process",
      title: "Process Application",
      icon: <IoIosStats />,
      total: statusCounts.Process,
      average:
        statusCounts.Total > 0
          ? (statusCounts.Process / statusCounts.Total) * 100
          : 0,
      badgecolor: "#26b9e2",
    },
    {
      statusId: "Accepted",
      title: "Accepted Application",
      icon: <FaUserPlus />,
      total: statusCounts.Accepted,
      average:
        statusCounts.Total > 0
          ? (statusCounts.Accepted / statusCounts.Total) * 100
          : 0,
      badgecolor: "#1abc9c",
    },
    {
      statusId: "Hold",
      title: "Hold Application",
      icon: <MdDownloading />,
      total: statusCounts.Hold,
      average:
        statusCounts.Total > 0
          ? (statusCounts.Hold / statusCounts.Total) * 100
          : 0,
      badgecolor: "#6c757d",
    },
    {
      statusId: "Rejected",
      title: "Rejected Application",
      icon: <MdCancel />,
      total: statusCounts.Rejected,
      average:
        statusCounts.Total > 0
          ? (statusCounts.Rejected / statusCounts.Total) * 100
          : 0,
      badgecolor: "#ec536c",
    },
    {
      statusId: "Returning",
      title: "Returning Application",
      icon: <PiKeyReturnFill />,
      total: statusCounts?.Returning,
      average:
        statusCounts.Total > 0
          ? (statusCounts?.Returning / statusCounts.Total) * 100
          : 0,
      badgecolor: "#d68b44",
    },
  ]

  return (
    <React.Fragment>
      <Miniwidget reports={reports} />

      <Row>
        <Col xl="4">
          <ApplicationsStatusChart
            reports={reports}
            statusCounts={statusCounts}
            total={statusCounts.Total}
          />
        </Col>

        <Col xl="8">
          <LatestUpdates />
        </Col>

        {/* <Col xl="6">
          <LatestOrders
            allApplicationsDataWithoutPagination={
              allApplicationsDataWithoutPagination
            }
          />
        </Col>
        <Col xl="6">
          <ReturningApplications
            allApplicationsDataWithoutPagination={
              allApplicationsDataWithoutPagination
            }
          />
        </Col> */}

        {/* <Col xl="6">
          <EmailSent />
        </Col> */}

        {/* <Col xl="3">
          <MonthlyEarnings2 />
        </Col> */}
      </Row>

      {/* <Row>
        <Col xl="4" lg="6">
          <Inbox />
        </Col>
        <Col xl="4" lg="6">
          <RecentActivity />
        </Col>
        <Col xl="4">
          <WidgetUser />
          <YearlySales />
        </Col>
      </Row> */}

      {/* <Row>
        <Col xl="6">
          <LatestTransactions />
        </Col>

        <Col xl="6">
          <LatestOrders applicationsData={applicationsData} />
        </Col>
      </Row> */}
    </React.Fragment>
  )
}

export default Dashboard